import { connect } from "react-redux";
import Balance from "./Balance";
import actionCreators from "../redux/actionCreators";
import { getBalance } from "../redux/selectors";
import isNumber from "lodash/isNumber";
import { getNumberInfo } from "Utils";
const mapStateToProps = state => {
    const balance = getBalance(state);
    return {
        balance: isNumber(balance) ? getNumberInfo(balance) : undefined
    };
};
const mapDispatchToProps = dispatch => ({
    onInitialized: () => {
        dispatch(actionCreators.actionApiGetBalance());
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(Balance);
